// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"15":"72b7146f","291":"7c8a259c","383":"577808b7","491":"e55ed887","526":"db4f49e9","556":"a98fb095","685":"825bf6b2","695":"e5582c59","737":"fb5f183b","898":"9bdf2aca","965":"080f7db3"}[chunkId] + ".js";
};